module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_endscopy/check_circle_disabled-ca30679db4114302c9c28d1ec353c281.svg";